/**
 * Next.js adapter for shared shortcuts package.
 *
 * Isolates framework-specific navigation hooks behind an adapter boundary.
 * Phase 1A creates the boundary; Phase 1B will make the import path injectable
 * for TanStack Start.
 */
export { useRouter } from 'next/navigation'
